// Shared formatting for figures on the model — the Model page and the Figures
// widget print a cell the same way.
import type { ModelCell, ModelPeriod } from './types';

export const columnLabel = (period: ModelPeriod) => {
    if (period.label) return period.label;
    const end = new Date(`${period.end}T00:00:00Z`);
    if (period.grain === 'year') return `FY ${end.getUTCFullYear()}`;
    return end.toLocaleDateString(undefined, {
        month: 'short', year: 'numeric', timeZone: 'UTC',
    });
};

export function formatFigure(cell: ModelCell | null, unit: string): string {
    const amount = cell?.value?.amount;
    if (cell === null || amount === undefined || amount === null) return '';
    const currency = cell.value.unit;
    if (unit === 'percent') return `${amount.toFixed(1)}%`;
    if (unit === 'months') return `${amount.toFixed(1)}`;
    if (unit === 'count') return amount.toLocaleString();
    if (unit === 'ratio') return amount.toFixed(2);
    if (unit === 'score') return amount.toLocaleString(undefined, { maximumFractionDigits: 1 });
    try {
        return amount.toLocaleString(undefined, {
            style: 'currency', currency: currency || 'GBP', maximumFractionDigits: 0,
        });
    } catch {
        return amount.toLocaleString(undefined, { maximumFractionDigits: 0 });
    }
}
